import React, { useContext, useRef, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

// Context
import MobileContext from 'Shared/contexts/MobileContext';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Hooks
import { useStickyObserver } from 'Shared/utils/hooks/use-sticky-observer';
import { useApp } from 'Shared/utils/hooks/use-app';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import ExpandButton from './ExpandButton/ExpandButton';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './ContentHeader.scss';

type Props = {
  navbarRef: {
    current: HTMLElement;
  };
  setIsExpanded: Function;
};

function ContentHeader({ setIsExpanded, navbarRef }: Props) {
  const isExpanded = useContext(ExpandNavbarContext);
  const stickyElementRef = useRef(null);

  const { appId, isTeamsEmbeddedTab } = useApp();
  const { isSticky } = useStickyObserver({ stickyElementRef, scrollingElementRef: navbarRef });
  const isMobile = useContext(MobileContext);
  const { tr } = useTranslation();

  const handleExpandClick = useCallback(() => setIsExpanded(state => !state), [setIsExpanded]);

  const baseClassName = 'ContentHeader';
  const classes = classnames(baseClassName, {
    [`${baseClassName}--sticky`]: isSticky,
    [`${baseClassName}--expanded`]: isExpanded,
  });

  return (
    <div ref={stickyElementRef} className={classes}>
      <NavLink
        to={PageUrls.HOME_PAGE}
        target={appId !== 'chrome' && !isTeamsEmbeddedTab ? '_self' : '_blank'}
        rel="noopener noreffer"
        className={`${baseClassName}__nav-link`}
      >
        <WpIllustration
          src={Illustrations.pi_logo_full_red_with_text}
          alt={tr('perform.navigation.pi_logo_full_alt')}
          className={`${baseClassName}__nav-link__logo`}
        />
      </NavLink>
      {!isMobile && !isTeamsEmbeddedTab && <ExpandButton onClick={handleExpandClick} />}
    </div>
  );
}

export default React.memo(ContentHeader);
